import { GridColumns, GridColumnVisibilityModel } from '@mui/x-data-grid';

export const staticColums: GridColumns = [
  // Obligatorias
  {
    field: 'ticketClientGroup',
    headerName: 'common.commonProperties.serviceRegistration',
    minWidth: 95,
    flex: 1
  },
  {
    field: 'statusName',
    headerName: 'common.commonProperties.ticketStatus',
    minWidth: 125,
    flex: 1
  },
  {
    field: 'clientName',
    headerName: 'common.commonProperties.client',
    minWidth: 80,
    maxWidth: 100,
    flex: 1
  },
  {
    field: 'clientTicketNumber',
    headerName: 'common.commonProperties.clientIncidentNumber',
    minWidth: 80,
    maxWidth: 130,
    flex: 1
  },
  {
    field: 'projectName',
    headerName: 'common.commonProperties.project',
    minWidth: 80,
    maxWidth: 100,
    flex: 1
  },
  {
    field: 'locationName',
    headerName: 'common.commonProperties.ubication',
    minWidth: 90,
    maxWidth: 120,
    flex: 1
  },
  {
    field: 'serviceTypeName',
    headerName: 'common.commonProperties.serviceType',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'serviceName',
    headerName: 'common.commonProperties.serviceSingular',
    minWidth: 80,
    maxWidth: 100,
    flex: 1
  },
  {
    field: 'assignedEngineerFullName',
    headerName: 'common.commonProperties.taskForce',
    minWidth: 100,
    flex: 1
  },
  // No Obligatorias
  {
    field: 'comercialName',
    headerName: 'common.commonProperties.comercialName',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'ubicationStatus',
    headerName: 'common.commonProperties.ubicationStatus',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'municipalityName',
    headerName: 'common.commonProperties.municipality',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'countryStateName',
    headerName: 'common.commonProperties.state',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'issueType',
    headerName: 'common.commonProperties.declaredFailure',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'actualFailure',
    headerName: 'common.commonProperties.actualFailure',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'serialNumbers',
    headerName: 'common.commonProperties.serialn',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'categoryName',
    headerName: 'common.commonProperties.categoryActive',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'subcategoryName',
    headerName: 'common.commonProperties.subCateforyActive',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'impactName',
    headerName: 'common.commonProperties.impact',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'urgencyName',
    headerName: 'common.commonProperties.urgency',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'priorityName',
    headerName: 'common.commonProperties.priorityActive',
    minWidth: 100,
    flex: 1
  }
];

export const columnVisibilityModel: GridColumnVisibilityModel = {
  ticketId: true,
  statusName: true,
  partnerName: true,
  clientName: true,
  projectName: false,
  locationName: true,
  serviceTypeName: true,
  serviceName: true,
  assignedEngineerFullName: true,
  requestedByUser: true,
  clientTicketNumber: true,
  ticketClientGroup: true,
  comercialName: false,
  ubicationStatus: false,
  municipalityName: false,
  countryStateName: false,
  issueType: false,
  actualFailure: false,
  tasksDescription: true,
  ticketDelayClassificationName: true,
  serialNumbers: false,
  createdUser: false,
  creationDateUTC: true,
  closedDate: true,
  lastDateHistoric: true,
  lastDatePendingValidation: true,
  firstCallSolution: true,
  scheduledDate: true,
  ticketProgress: true,
  flags: false,
  steps: true,
  ticketCloseFields: false,
  comunicationAdvanceSolution: true,
  interventionCode: false,
  startDate: false,
  externalOrigin: false,
  externalEventId: false,
  categoryName: false,
  subcategoryName: false,
  impactName: false,
  urgencyName: false,
  priorityName: false,
  itilTranslatedDescription: false,
  itilTranslatedCloseComment: false
};

export const programmedColumnVisibilityModel: GridColumnVisibilityModel = {
  ticketId: true,
  statusName: true,
  partnerName: true,
  clientName: true,
  locationName: true,
  serviceTypeName: true,
  serviceName: true,
  assignedEngineerFullName: true,
  startDate: true,
  tasksDescription: true
};

export const headerToExportProgramedColumns = [
  {
    key: 'ticketId',
    label: 'common.commonProperties.ticketNumber'
  },
  {
    key: 'statusName',
    label: 'common.commonProperties.ticketStatus'
  },
  {
    key: 'partnerName',
    label: 'common.commonProperties.partnerSingular'
  },
  {
    key: 'clientName',
    label: 'common.commonProperties.client'
  },
  {
    key: 'projectName',
    label: 'common.commonProperties.project'
  },
  {
    key: 'locationName',
    label: 'common.commonProperties.ubication'
  },
  {
    key: 'serviceTypeName',
    label: 'common.commonProperties.serviceType'
  },
  {
    key: 'serviceName',
    label: 'common.commonProperties.serviceSingular'
  },
  {
    key: 'assignedEngineerFullName',
    label: 'common.commonProperties.taskForce'
  },
  {
    key: 'tasksDescription',
    label: 'common.commonProperties.activitiesDescription'
  },
  {
    key: 'itilTranslatedDescription',
    label: 'common.commonProperties.itilTranslatedDescription'
  },
  {
    key: 'itilTranslatedCloseComment',
    label: 'common.commonProperties.itilTranslatedCloseComment'
  },
  {
    key: 'startDate',
    label: 'common.commonProperties.startProgrammedDate'
  },
  {
    key: 'comunicationAdvanceSolution',
    label: 'common.commonProperties.comunicationAdvSol'
  }
];

export const headerToExport = [
  { key: 'ticketId', label: 'common.commonProperties.ticketNumber' },
  { key: 'statusName', label: 'common.commonProperties.ticketStatus' },
  { key: 'clientName', label: 'common.commonProperties.client' },
  {
    key: 'clientTicketNumber',
    label: 'common.commonProperties.clientIncidentNumber'
  },
  { key: 'projectName', label: 'common.commonProperties.project' },
  { key: 'locationName', label: 'common.commonProperties.ubication' },
  { key: 'serviceTypeName', label: 'common.commonProperties.serviceType' },
  {
    key: 'serviceName',
    label: 'common.commonProperties.serviceSingular',
    width: 120
  },
  {
    key: 'assignedEngineerFullName',
    label: 'common.commonProperties.taskForce'
  },
  {
    key: 'ticketClientGroup',
    label: 'common.commonProperties.serviceRegistration'
  },
  {
    key: 'partnerName',
    label: 'common.commonProperties.partnerSingular'
  },
  { key: 'comercialName', label: 'common.commonProperties.comercialName' },
  { key: 'ubicationStatus', label: 'common.commonProperties.ubicationStatus' },
  { key: 'municipalityName', label: 'common.commonProperties.municipality' },
  { key: 'countryStateName', label: 'common.commonProperties.state' },
  { key: 'issueType', label: 'common.commonProperties.declaredFailure' },
  { key: 'actualFailure', label: 'common.commonProperties.actualFailure' },
  {
    key: 'tasksDescription',
    label: 'common.commonProperties.activitiesDescription'
  },
  {
    key: 'itilTranslatedDescription',
    label: 'common.commonProperties.itilTranslatedDescription'
  },
  {
    key: 'itilTranslatedCloseComment',
    label: 'common.commonProperties.itilTranslatedCloseComment'
  },
  {
    key: 'ticketDelayClassificationName',
    label: 'common.commonProperties.delayTicketName'
  },
  { key: 'closedDate', label: 'common.commonProperties.closedDate' },
  {
    key: 'lastDateHistoric',
    label: 'common.commonProperties.historicDate'
  },
  {
    key: 'lastDatePendingValidation',
    label: 'common.commonProperties.pendingForValidationDate'
  },
  { key: 'serialNumbers', label: 'common.commonProperties.serialn' },
  { key: 'createdUser', label: 'common.commonProperties.ticketCreatedUser' },
  { key: 'creationDateUTC', label: 'common.commonProperties.startDate' },
  {
    key: 'firstCallSolution',
    label: 'common.commonProperties.firstCallSolution'
  },
  { key: 'scheduledDate', label: 'common.commonProperties.dueDate' },
  {
    key: 'ticketProgress',
    label: 'common.commonProperties.followUpPercentaje'
  },
  {
    key: 'comunicationAdvanceSolution',
    label: 'common.commonProperties.comunicationAdvSol'
  },
  {
    key: 'requestedByUser',
    label: 'common.commonProperties.requestedBy'
  },
  {
    key: 'externalEventId',
    label: 'common.commonProperties.externalEventId'
  },
  {
    key: 'externalOrigin',
    label: 'common.commonProperties.externalOrigin'
  },
  {
    key: 'categoryName',
    label: 'common.commonProperties.categoryActive'
  },
  {
    key: 'subcategoryName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'impactName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'urgencyName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'priorityName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'requesterEmail',
    label: 'common.commonProperties.applicantEmail'
  }
];

export const headerToExportHistoric = [
  { key: 'ticketId', label: 'common.commonProperties.ticketNumber' },
  { key: 'statusName', label: 'common.commonProperties.ticketStatus' },
  { key: 'clientName', label: 'common.commonProperties.client' },
  {
    key: 'clientTicketNumber',
    label: 'common.commonProperties.clientIncidentNumber'
  },
  { key: 'projectName', label: 'common.commonProperties.project' },
  { key: 'locationName', label: 'common.commonProperties.ubication' },
  { key: 'serviceTypeName', label: 'common.commonProperties.serviceType' },
  {
    key: 'serviceName',
    label: 'common.commonProperties.serviceSingular',
    width: 120
  },
  {
    key: 'assignedEngineerFullName',
    label: 'common.commonProperties.taskForce'
  },
  {
    key: 'ticketClientGroup',
    label: 'common.commonProperties.serviceRegistration'
  },
  {
    key: 'partnerName',
    label: 'common.commonProperties.partnerSingular'
  },
  { key: 'comercialName', label: 'common.commonProperties.comercialName' },
  { key: 'ubicationStatus', label: 'common.commonProperties.ubicationStatus' },
  { key: 'municipalityName', label: 'common.commonProperties.municipality' },
  { key: 'countryStateName', label: 'common.commonProperties.state' },
  { key: 'issueType', label: 'common.commonProperties.declaredFailure' },
  { key: 'actualFailure', label: 'common.commonProperties.actualFailure' },
  {
    key: 'tasksDescription',
    label: 'common.commonProperties.activitiesDescription'
  },
  {
    key: 'itilTranslatedDescription',
    label: 'common.commonProperties.itilTranslatedDescription'
  },
  {
    key: 'itilTranslatedCloseComment',
    label: 'common.commonProperties.itilTranslatedCloseComment'
  },
  {
    key: 'ticketDelayClassificationName',
    label: 'common.commonProperties.delayTicketName'
  },
  {
    key: 'categoryName',
    label: 'common.commonProperties.categoryActive'
  },
  {
    key: 'subcategoryName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'impactName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'urgencyName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'priorityName',
    label: 'common.commonProperties.subCateforyActive'
  },
  {
    key: 'requesterEmail',
    label: 'common.commonProperties.applicantEmail'
  },
  { key: 'ticketCloseFields', label: 'common.commonProperties.requiredFields' },
  {
    key: 'itilTranslatedCloseComment',
    label: 'common.commonProperties.itilTranslatedCloseComment'
  },
  { key: 'serialNumbers', label: 'common.commonProperties.serialn' },
  { key: 'createdUser', label: 'common.commonProperties.ticketCreatedUser' },
  { key: 'creationDateUTC', label: 'common.commonProperties.startDate' },
  { key: 'closedDate', label: 'common.commonProperties.closedDate' },
  {
    key: 'lastDateHistoric',
    label: 'common.commonProperties.historicDate'
  },
  {
    key: 'lastDatePendingValidation',
    label: 'common.commonProperties.pendingForValidationDate'
  },
  {
    key: 'firstCallSolution',
    label: 'common.commonProperties.firstCallSolution'
  },
  { key: 'scheduledDate', label: 'common.commonProperties.dueDate' },
  {
    key: 'ticketProgress',
    label: 'common.commonProperties.followUpPercentaje'
  },
  {
    key: 'comunicationAdvanceSolution',
    label: 'common.commonProperties.comunicationAdvSol'
  }
];
